export const InlineFieldHint = () => (
  <span className="mt-1 text-[11px] leading-4 text-ink-subtle">
    Enter to save · Esc to cancel
  </span>
)
